import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircleIcon, ClockIcon, EyeIcon, CopyIcon, SparklesIcon, SlidersHorizontalIcon } from 'lucide-react';
const reasons = [{
  icon: PlayCircleIcon,
  title: 'TU CLASE EMPIEZA CON ALGO CONCRETO',
  desc: 'No comienzas buscando qué hacer: eliges el tema y partes de un recurso listo para utilizar.'
}, {
  icon: ClockIcon,
  title: 'LA PLANIFICACIÓN DEJA DE OCUPAR TUS TARDES',
  desc: 'Materiales preparados para reducir el tiempo que hoy dedicas a crear, buscar y adaptar.'
}, {
  icon: EyeIcon,
  title: 'LA TEORÍA SE VUELVE MÁS VISUAL',
  desc: 'Apoyos, ejemplos, imágenes y esquemas para explicar contenidos que suelen resultar abstractos.'
}, {
  icon: CopyIcon,
  title: 'TIENES ALTERNATIVAS CUANDO LAS NECESITAS',
  desc: 'Las versiones A y B ayudan a practicar, evaluar o recuperar sin improvisar otra actividad desde cero.'
}, {
  icon: SparklesIcon,
  title: 'LOS ESTUDIANTES PARTICIPAN MÁS',
  desc: 'Juegos, desafíos e historietas crean otras puertas de entrada a los contenidos sin perder el rigor de Química.'
}, {
  icon: SlidersHorizontalIcon,
  title: 'UTILIZA SOLO LO QUE NECESITAS',
  desc: 'Documentos completos y fichas individuales para imprimir, proyectar o compartir según tu clase.'
}];
export function WhyChoose() {
  return <section className="relative py-8 md:py-16 px-4 bg-chem-ice overflow-hidden" data-id="element-289" data-mp="2rd9s5dyf5uoo">
      <div aria-hidden="true" className="chem-lattice pointer-events-none absolute inset-0" data-id="element-290" data-mp="2rb6tk5j7at8c" />
      <div className="relative max-w-6xl mx-auto" data-id="element-291" data-mp="31335aje7mhv1">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-chem-navy mb-6 md:mb-10" data-id="element-292" data-mp="312tewup968ot">
          ¿Por qué elegir el MEGAPACK?
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-293" data-mp="364aaqbsvr4yj">
          {reasons.map((reason, index) => {
          const Icon = reason.icon;
          return <motion.article key={reason.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="bg-white p-6 md:p-7 rounded-3xl border border-chem-petrol/12 shadow-lg shadow-chem-navy/5 flex flex-col" data-id="element-294" data-mp="3i50862oka1zw" data-mpi={index}>
                <span className="w-12 h-12 bg-chem-ice rounded-2xl flex items-center justify-center mb-5 text-chem-petrol" data-id="element-295" data-mp="4nzmlwjh25fv">
                  <Icon className="w-6 h-6" strokeWidth={2.2} data-id="element-296" data-mp="eo04de1p0dhy" />
                </span>
                <h3 className="text-base md:text-lg font-black text-chem-navy mb-2 leading-tight uppercase tracking-tight" data-id="element-297" data-mp="elnrvgepevca">
                  {reason.title}
                </h3>
                <p className="text-chem-navy/65 text-sm md:text-base font-medium leading-relaxed" data-id="element-298" data-mp="2gfn1lxc6h4mv">
                  {reason.desc}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}